import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const CloseIcon: React.FC<IconProps> = ({ 
  width = 14, 
  height = 14, 
  className = "" 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 14 14" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M13 1L1 13M1 1L13 13" 
        stroke="white" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};
